import React from 'react'
import { Info } from 'react-feather'
import './SpreadsheetInfoBanner.scss'

export function SpreadsheetInfoBanner() {
  return (
    <div className="spreadsheet-info-banner" role="status">
      <Info className="spreadsheet-info-banner__icon" size={18} aria-hidden />
      <p className="spreadsheet-info-banner__text">
        A primeira linha deve ser o cabeçalho. A linha de exemplo será ignorada
        automaticamente.
      </p>
    </div>
  )
}
